import React from "react";
import { Link } from "react-router-dom";
import { COLORS, FONT, RADIUS, SHADOW } from "../theme";

const ATUALIZADO_EM = "08 de setembro de 2026";

function Secao({ titulo, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: COLORS.text, margin: "0 0 10px" }}>{titulo}</h2>
      <div style={{ fontSize: 15, lineHeight: 1.7, color: COLORS.textMid }}>{children}</div>
    </section>
  );
}

export default function Privacidade() {
  return (
    <div style={{ minHeight: "100dvh", background: COLORS.bg, fontFamily: FONT }}>
      <header
        style={{
          background: `linear-gradient(120deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 100%)`,
          padding: "22px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={`${process.env.PUBLIC_URL}/icon-pontozipar.png`} alt="" style={{ width: 32, height: 32, borderRadius: 8 }} />
          <span style={{ color: COLORS.white, fontWeight: 700, fontSize: 18 }}>PontoZipar</span>
        </div>
        <Link to="/login" style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, textDecoration: "none" }}>
          ← Voltar ao login
        </Link>
      </header>

      <main style={{ maxWidth: 760, margin: "0 auto", padding: "40px 24px 80px" }}>
        <div
          style={{
            background: COLORS.surface,
            borderRadius: RADIUS.xl,
            boxShadow: SHADOW.card,
            border: `1px solid ${COLORS.border}`,
            padding: "36px 40px",
          }}
        >
          <h1 style={{ fontSize: 26, fontWeight: 800, color: COLORS.text, margin: "0 0 6px" }}>
            Política de Privacidade
          </h1>
          <p style={{ fontSize: 13, color: COLORS.textLight, margin: "0 0 32px" }}>
            Última atualização: {ATUALIZADO_EM}
          </p>

          <Secao titulo="1. Quem somos">
            O PontoZipar é desenvolvido e operado pela <strong>Zipar Soluções Empresariais LTDA</strong>,
            CNPJ 68.173.181/0001-91. Esta política explica quais dados o sistema de ponto eletrônico
            PontoZipar (site e aplicativo) coleta, para que usamos e como protegemos.
          </Secao>

          <Secao titulo="2. A quem esta política se aplica">
            A funcionários, gestores e administradores das empresas clientes que usam o PontoZipar para
            registrar e gerenciar jornada de trabalho.
          </Secao>

          <Secao titulo="3. Quais dados coletamos">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Dados cadastrais: nome, CPF, cargo, telefone, e-mail e matrícula, inseridos pela empresa empregadora no cadastro.</li>
              <li>Foto (selfie) tirada no momento de bater o ponto, para confirmar que foi a própria pessoa que fez o registro.</li>
              <li>Localização (GPS) no momento da batida, para confirmar que o registro foi feito em um posto de trabalho autorizado.</li>
              <li>Horários de entrada, saída e intervalos registrados, e eventuais justificativas/atestados anexados.</li>
            </ul>
          </Secao>

          <Secao titulo="4. Para que usamos esses dados">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Cumprir a legislação trabalhista brasileira (CLT), que exige registro confiável de jornada.</li>
              <li>Permitir que a empresa empregadora gerencie escalas, banco de horas e hora extra.</li>
              <li>Confirmar identidade e localização de quem bate o ponto, prevenindo fraude no registro.</li>
            </ul>
          </Secao>

          <Secao titulo="5. Quem é responsável pelos dados">
            O PontoZipar é a ferramenta usada pela empresa que emprega você. Os dados da sua jornada de
            trabalho pertencem e são geridos por essa empresa — ela é a responsável legal pelas
            informações (controladora, segundo a LGPD). A Zipar Soluções Empresariais LTDA fornece a
            tecnologia e armazena/processa esses dados a mando da empresa contratante, seguindo as
            instruções dela (operadora, segundo a LGPD).
          </Secao>

          <Secao titulo="6. Com quem compartilhamos">
            Não vendemos nem compartilhamos esses dados com terceiros para fins de publicidade. O acesso
            é restrito à própria empresa empregadora (gestores e RH autorizados) e à equipe técnica da
            Zipar Soluções Empresariais, exclusivamente para manter o sistema funcionando. Podemos
            divulgar informações caso exigido por lei ou ordem judicial.
          </Secao>

          <Secao titulo="7. Por quanto tempo guardamos">
            Os registros de ponto são mantidos pelo prazo exigido pela legislação trabalhista brasileira
            (em geral até 5 anos, prazo de prescrição de ações trabalhistas), mesmo após o fim do vínculo
            empregatício, pois servem de prova em eventual disputa trabalhista.
          </Secao>

          <Secao titulo="8. Como protegemos seus dados">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Conexão criptografada (HTTPS) entre o app/site e nossos servidores.</li>
              <li>Senhas armazenadas de forma criptografada, nunca em texto puro.</li>
              <li>Cada registro de ponto recebe uma assinatura digital própria, que permite detectar qualquer alteração posterior.</li>
              <li>Acesso aos dados restrito por perfil: funcionário só vê o próprio histórico; gestor só vê sua equipe.</li>
            </ul>
          </Secao>

          <Secao titulo="9. Seus direitos (LGPD)">
            Você pode solicitar, através da empresa que te emprega ou diretamente pelo contato abaixo:
            acesso aos seus dados, correção de informação incorreta, esclarecimento sobre com quem os
            dados são compartilhados, e exclusão de dados quando a lei permitir (lembrando que registros
            de ponto têm guarda obrigatória durante e após o vínculo empregatício, pelo prazo da lei).
          </Secao>

          <Secao titulo="10. Permissões do aplicativo (câmera e localização)">
            O app pede acesso à câmera apenas no momento de bater o ponto, para a selfie de confirmação —
            essa foto não é usada para nenhum outro fim. O app pede acesso à localização apenas no
            momento de bater o ponto, para confirmar que o registro foi feito dentro do posto de trabalho
            autorizado. Não rastreamos sua localização em segundo plano, fora desses momentos.
          </Secao>

          <Secao titulo="11. Alterações nesta política">
            Podemos atualizar este texto de tempos em tempos. A data da última atualização fica sempre no
            topo desta página.
          </Secao>

          <Secao titulo="12. Contato">
            Dúvidas sobre privacidade e proteção de dados:{" "}
            <a href="mailto:contato@pontozipar.com.br" style={{ color: COLORS.primary }}>
              contato@pontozipar.com.br
            </a>
          </Secao>
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: COLORS.textLight, marginTop: 20 }}>
          Zipar Soluções Empresariais LTDA — CNPJ 68.173.181/0001-91
        </p>
      </main>
    </div>
  );
}
